<script>
	const userContext = require('core/userContext');
	const page = require('page');

	module.exports = {
		components: {
			'student-library-suggestions': require('components/student-library-suggestions.vue').default
		},
		props: ['route-context', 'workspace', 'assignment', 'product'],
		modelData: ['activeClass', 'gcAddon'],
		data: function () {
			return {
				studentName: ''
			};
		},
		computed: {
			library() {
				let activeClass = this.activeClass;
				return activeClass && activeClass.as.library;
			},
			productType() {
				let product = this.product;
				let pt = null;
				if (product) {
					pt = product.productType;
				}
				return pt;
			},
			grade() {
				let activeClass = this.activeClass;
				let g = activeClass ? activeClass.g || activeClass.grade : null;
				return g;
			},
			uuid() {
				let product = this.product;
				let puuid = null;
				if (product) {
					puuid = product.uuid;
				}
				return puuid;
			},
			showSuggestions() {
				let library = this.library;
				let productType = this.productType;
				let uuid = this.uuid;
				let grade = this.grade;

				return library && productType && uuid && grade;
			}
		},
		mounted() {
			this.studentName = userContext.getFullName();

			if (this.workspace.s !== 's' && !this.workspace.scoreState.a) {
				page('/student');
			}
		}
	};
</script>
<template>
	<div class="main-content wrapper">
		<h1>Assignment Submitted.<br />Thank you!</h1>
		<p v-if="gcAddon">Don't forget to "Turn in" the assignment in Google Classroom</p>
		<template v-else>
			<student-library-suggestions
				v-if="showSuggestions"
				:grade="grade"
				:product="product">
			</student-library-suggestions>
			<div>
				<a
					:href="`/student?${routeContext.querystring}`"
					class="button -large">
					Return to Assignments
				</a>
				<a
					href="/logout"
					class="button -large">
					Logout
				</a>
			</div>
		</template>
	</div>
</template>
